import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getControleDeAcesso } from '../AuthUtils';

/**
 * Evita repetir `useSelector` + `getControleDeAcesso(codigo, authUserInfo)`:
 *
 *   const podeAcessar = useAcesso();
 *   podeAcessar('cad_credor_c');
 */
export const useAcesso = () => {
  const authUserInfo = useSelector(({ auth }) => auth.authUserInfo);

  return useCallback(
    (codigo) => getControleDeAcesso(codigo, authUserInfo),
    [authUserInfo]
  );
};

export default useAcesso;
